"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getProductUrl = exports.PRODUCTS_URL = void 0;
const PRODUCTS_URL = exports.PRODUCTS_URL = '/products/product?code=';
const getProductUrl = code => `${PRODUCTS_URL}${code}`;
exports.getProductUrl = getProductUrl;